<template>
    <div>
        <div class="directory-section">
            <div class="container">
                <div class="heading">
                    <h4>Is your company listed accurately in these online directories?</h4>
                </div>
                <div class="directory-wrapper">
                      <div class="row-wrap">
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/facebook.png')" />
                                </div>
                                <span>Facebook</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/Google.png')" />
                                </div>
                                <span>Google</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/Yep_Apple.png')" />
                                </div>
                                <span>Apple</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/foursquare.png')" />
                                </div>
                                <span>Foursquare</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/Bing.png')" />
                                </div>
                                <span>Bing</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                   <img :src="require('@/assets/here.png')" />
                                </div>
                                <span>Here</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/cylex.png')" />
                                </div>
                                <span>Cylex</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/yellowpages.png')" />
                                </div>
                                <span>Yellow Pages</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/Waze.png')" />
                                </div>
                                <span>Waze</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                   <img :src="require('@/assets/tomtom.png')" />
                                </div>
                                <span>Tomtom</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/Yep_Instagram.png')" />
                                </div>
                                <span>Instagram</span>
                            </a>
                        </div>
                        <div class="column-wrap">
                            <a class="" href="/#">
                                <div class="image">
                                    <img :src="require('@/assets/Yep_Navmii.png')" />
                                </div>
                                <span>Navmii</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Directories",
    }
</script>